<div mat-dialog-content>

  <div class="hymnNumber">
    <span>{{hymnNumber}}</span>
  </div>

  <hr>

  <div class="dialpad-row">
    <button class="dialpad" (click)="dial('1')" mat-fab color="primary">1</button>
    <button class="dialpad"(click)="dial('2')"  mat-fab color="primary">2</button>
    <button class="dialpad"(click)="dial('3')"  mat-fab color="primary">3</button>
  </div>

  <div class="dialpad-row">
    <button class="dialpad"(click)="dial('4')" mat-fab color="primary">4</button>
    <button class="dialpad"(click)="dial('5')"  mat-fab color="primary">5</button>
    <button class="dialpad"(click)="dial('6')"  mat-fab color="primary">6</button>
  </div>

  <div class="dialpad-row">
    <button class="dialpad"(click)="dial('7')"  mat-fab color="primary">7</button>
    <button class="dialpad"(click)="dial('8')"  mat-fab color="primary">8</button>
    <button class="dialpad"(click)="dial('9')"  mat-fab color="primary">9</button>
  </div>

  <div class="dialpad-row">
    <button class="dialpad" mat-fab color="primary" (click)="onCancel()">
      <mat-icon class="dialpad-icon">clear</mat-icon>
    </button>
    <button class="dialpad"(click)="dial('0')"  mat-fab color="primary">0</button>
    <button class="dialpad" mat-fab color="primary" (click)="onHymn()">
      <mat-icon class="dialpad-icon">forward</mat-icon>
    </button>
  </div>
</div>
